export default __webpack_public_path__ + "static/media/tags.ac1a238e.png";